/* eslint-disable react/prop-types */
import * as InactivityActions from "actions/InactivityActions";
import * as PlaybackStateActions from "actions/PlaybackStateActions";
import getAdPlaying from "selectors/ads/getAdPlaying";
import getIsMobile from "selectors/device/getIsMobile";
import getPixelRatio from "utils/getPixelRatio";
import getPlayAd from "selectors/ads/getPlayAd";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import getShowSlideshowGallery from "selectors/getShowSlideshowGallery";
import getUsePersistentVideo from "selectors/device/getUsePersistentVideo";
import getUsePlaybackResumeDelay from "selectors/device/getUsePlaybackResumeDelay";
import getWaitingForInitialPlay from "selectors/device/getWaitingForInitialPlay";
import makeGetVideoFocalPoint from "selectors/makeGetVideoFocalPoint";
import React from "react";
import Video from "components/Video";
import { AnalyticsActions } from "utils/Analytics";
import { compose, withHandlers } from "recompose";
import { connect } from "react-redux";

import { VisibleTileProvider } from "../context/VisibleTileContext";

const makeMapStateToProps = () => {
  const getVideoFocalPoint = makeGetVideoFocalPoint();

  return (state, ownProps) => {
    const waitingForInitialPlay = getWaitingForInitialPlay(state, ownProps);
    const pixelRatio = getPixelRatio();
    const videoEntity = state.story.entities.videos[ownProps.videoId];
    const is360 = videoEntity.is360;
    const playbackState = getPlaybackState(state, ownProps);

    return {
      adPlaying: getAdPlaying(state, ownProps),
      disableContain: ownProps.disableContain || is360,
      videoFocalPoint:
        ownProps.focalPoint ||
        (!is360
          ? getVideoFocalPoint(state, ownProps)
          : {
              focalX: 0,
              focalY: 0,
              height: state.viewport.dimensions.height,
              width: state.viewport.dimensions.width,
            }),
      forcingChapterCover: state.forceChapterCover,
      loopingVideosInactive: state.inactivity.loopingVideos,
      measureVideoDimensions: !is360,
      onTrackMediaProgress: () =>
        AnalyticsActions.mediaProgress({
          chapterId: ownProps.chapterId,
          playbackState,
        }),
      pixelRatio,
      playAd: getPlayAd(state, ownProps),
      playAfterSeek:
        !getShowSlideshowGallery(state, ownProps) &&
        !state.playerOptions.designMode,
      playing: playbackState.playing,
      posterImageStored: !!playbackState.posterImage,
      scrubbing: playbackState.scrubbing,
      seeking: playbackState.seeking,
      time: playbackState.time,
      usePersistentVideo: getUsePersistentVideo(state, ownProps),
      usePlaybackResumeDelay: getUsePlaybackResumeDelay(state, ownProps),
      userInitiatedPause: playbackState.userInitiatedPause,
      useTapToRestore: getIsMobile(state, ownProps) && !!is360,
      waitingForInitialPlay,
    };
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onComponentDidMount: () =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        scrubbing: false,
        seeking: false,
      }),
    ),
  onSetSeeking: (newSeekState) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        seeking: newSeekState,
      }),
    ),
  onSetPlaying: (newPlayState) => {
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        playing: newPlayState,
      }),
    );
  },
  onSetUserInitiatedPause: (newPauseState) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        userInitiatedPause: newPauseState,
      }),
    ),
  onSetAdTime: (newTime) => {
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        adTime: newTime,
      }),
    );
  },
  onSetTime: (newTime) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        time: newTime,
      }),
    ),
  onSetStalled: (newStalledState) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        stalled: newStalledState,
      }),
    ),
  onSetDuration: (newDuration) =>
    dispatch(
      PlaybackStateActions.changePlaybackState(ownProps, {
        duration: newDuration,
      }),
    ),
  onTap: () => dispatch(InactivityActions.reportActivity()),
});

const connector = connect(makeMapStateToProps, mapDispatchToProps);

export default compose(
  connector,
  withHandlers({
    onTrackMediaProgress: (props) => props.onTrackMediaProgress,
  }),
  (Component) => {
    return (props) => {
      return (
        <VisibleTileProvider isActive={props.active} videoId={props.videoId}>
          <Component {...props} />
        </VisibleTileProvider>
      );
    };
  },
)(Video);
